// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"04bc5f08","410":"40bf79ab","443":"a4faa15e","453":"cc7164aa","840":"8207c312"}[chunkId] + ".chunk.js";
};